<div class="infra-nudge-container flex gap-4">
    <img [src]="images?.PENDING_BILL_NUDGE" alt="pending bill" />
    <div class="flex flex_column justify-content-between gap-3">
        <div class="flex flex_column gap-2">
            <div class="fs-24 fw-600 clr-333 infra-header">{{ (isNegative ? 'NUDGE.PAYMENT_DUE' : 'NUDGE.SUBSCRIPTION_DUE') | fallbackTranslate }}</div>
            <div class="fs-16 clr-666 infra-sub-header">{{ (isNegative ? 'NUDGE.PAYMENT_RENEW_TEXT' : 'NUDGE.SUBSCRIPTION_RENEW_TEXT') | fallbackTranslate }}
            </div>
        </div>
        <div class="flex gap-4 justify-content-end align_center fs-14">
            <button class="btn--secondary clr-999" (click)="dismissInfraNudge()">{{ 'NUDGE.DISMISS_BUTTON_TEXT' |
                fallbackTranslate }}</button>
            <button class="btn--primary fw-600 flex flex-center" (click)="renew()">{{ (isNegative ? 'NUDGE.PAY_NOW_BUTTON_TEXT' : 'NUDGE.SUBSCRIPTION_BUTTON_TEXT') |
                fallbackTranslate }}</button>
        </div>
    </div>
</div>